import styled from '@mui/material/styles/styled';

export const Root = styled('div')(({theme}) => ({
  display: 'flex',
  alignItems: 'flex-start',
  flexWrap: 'wrap',
  gap: '16px',
  overflow: 'auto',
  padding: '32px 16px',
  [theme.breakpoints.up('md')]: {
    padding: 40
  }
}));
